import { Component, OnInit, HostListener, Output, EventEmitter, Input } from '@angular/core';
declare var $: any;
@Component({
  selector: 'app-side-nav',
  templateUrl: './side-nav.component.html',
  styleUrls: ['./side-nav.component.css']
})
export class SideNavComponent implements OnInit {

  @Input() menuItems;
  @Output() toggleSidebar: EventEmitter<any> = new EventEmitter<any>();

  constructor() { }
  isSubmenuActive = false;
  isVisibleMenu = false;

  // New menu package related

  config = {
    paddingAtStart: true,
    interfaceWithRoute: true,
    fontColor: '#fff',
    listBackgroundColor: 'var(--background-tertiary)',
    // backgroundColor: 'var(--background-secondary)',
    selectedListFontColor: '#fff',
    highlightOnSelect: true,
    collapseOnSelect: true,
    useDividers: false,
    rtlLayout: false
  };


  ngOnInit() {
  }
  // If window window width is less than 992px toggle the sidebar after every click on the menuitem.
  @HostListener('click', ['$event'])
  onClick(e) {
    if (e.target.className == 'menuItem active' || e.target.className == 'menuItem') {
      if (window.screen.width < 992) {
        this.toggleSidebar.emit();
      }
    }
  }

}
